import React from 'react';
import { styled } from '@mui/material/styles';
import { Grid, Typography } from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';

import ParterAmericaFord from '../../assets/images/parter_america_ford.svg';
import ParterAudiCenterRecife from '../../assets/images/parter_audi_center_recife.svg';
import ParterBremen from '../../assets/images/parter_bremen.svg';
import ParterFiatFiori from '../../assets/images/parter_fiat_fiori.svg';
import ParterFioriJeep from '../../assets/images/parter_fiori_jeep.svg';
import ParterLexus from '../../assets/images/parter_lexus.svg';
import ParterMardisa from '../../assets/images/parter_mardisa.svg';
import ParterParviMercedes from '../../assets/images/parter_parvi_mercedes.svg';
import ParterHyundaiPateo from '../../assets/images/parter_hyundai_pateo.svg';
import ParterToyolex from '../../assets/images/parter_toyolex.svg';
import ParterLandRoverWay from '../../assets/images/parter_land_rover_way.svg';
import ParterJaguarWay from '../../assets/images/parter_jaguar_way.svg';
import ParterAutoparviSeminovos from '../../assets/images/parter_autoparvi_seminovos.svg';

const RootGrid = styled(Grid)({
  position: 'relative',
  width: '100%',
  margin: 0,
  backgroundColor: '#FFFFFF',
  borderTop: '1px solid #E0E4E8',
  borderBottom: '1px solid #E0E4E8',
});

const ContentContainer = styled('div')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: theme.spacing(5, 4),
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(4, 2),
  },
}));

const Title = styled(Typography)(({ theme }) => ({
  color: 'rgba(1, 47, 71, 0.45)',
  fontSize: '14px',
  fontWeight: 600,
  letterSpacing: '0.2em',
  textTransform: 'uppercase',
  marginBottom: theme.spacing(4),
  textAlign: 'center',
  fontFamily: 'GT Haptik, Roboto, sans-serif',
  [theme.breakpoints.down('sm')]: {
    fontSize: '12px',
    marginBottom: theme.spacing(3),
  },
}));

const StyledSwiper = styled(Swiper)(({ theme }) => ({
  width: '100%',
  maxWidth: '1200px',
  padding: theme.spacing(1),
  '& .swiper-slide': {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '90px',
  },
}));

const PartnerImage = styled('img')(({ theme }) => ({
  width: 'auto',
  height: '100%',
  maxHeight: '72px',
  objectFit: 'contain',
  [theme.breakpoints.down('sm')]: {
    maxHeight: '60px',
  },
}));

const OurPartners = () => {
  const partners = [
    { image: ParterAmericaFord, alt: 'América Ford' },
    { image: ParterAudiCenterRecife, alt: 'Audi Center Recife' },
    { image: ParterBremen, alt: 'Bremen' },
    { image: ParterFiatFiori, alt: 'Fiat Fiori' },
    { image: ParterFioriJeep, alt: 'Fiori Jeep' },
    { image: ParterLexus, alt: 'Lexus' },
    { image: ParterMardisa, alt: 'Mercedes Mardisa' },
    { image: ParterParviMercedes, alt: 'Mercedes Parvi' },
    { image: ParterHyundaiPateo, alt: 'Hyundai Pateo' },
    { image: ParterToyolex, alt: 'Toyolex' },
    { image: ParterLandRoverWay, alt: 'Land Rover Way' },
    { image: ParterJaguarWay, alt: 'Jaguar Way' },
    { image: ParterAutoparviSeminovos, alt: 'Autoparvi seminovos' }

  ];

  return (
    <RootGrid>
      <ContentContainer>
        <Title variant="h2">
          Marcas Que Confiam
        </Title>
        <StyledSwiper
          modules={[Autoplay]}
          spaceBetween={30}
          slidesPerView={2}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          breakpoints={{
            768: {
              slidesPerView: 3,
              spaceBetween: 40,
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 50,
            },
          }}
        >
          {partners.map((partner, index) => (
            <SwiperSlide key={index}>
              <PartnerImage 
                src={partner.image} 
                alt={partner.alt}
              />
            </SwiperSlide>
          ))}
        </StyledSwiper>
      </ContentContainer>
    </RootGrid>
  );
};

export default OurPartners; 